import { CurrentUser } from '@appTypes/CurrentUser';
import { StoreDetails } from '@appTypes/StoreDetails';
import Loader from '@components/shared/loader/Loader';
import { useConfig } from '@hooks/UseConfig';
import { GetOneFromPath } from '@services/api/GenericClient';
import { GetToken, setAuthHeader } from '@services/utils';
import { CampaignUserList } from '@services/utils/CampaignUserList';
import { AppState } from '@store/AppState';
import Papa from 'papaparse';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

export const CampaignTest: FC = () => {
  const currentUser = useSelector<AppState, CurrentUser>((state) => state.currentUser);
  const [dealerList, setDealerList] = useState<any>([]);
  const [dealDropList, setDealDropList] = useState<any>([]);
  const [fileList, SetFileList] = useState<any>([]);
  const [activeStore, setActiveStore] = useState<any>();
  const [loading, SetLoading] = useState<boolean>(false);
  const userEmail = currentUser.userName;
  const { apiUrl } = useConfig();

  useEffect(() => {
    getStores();
  }, []);

  useEffect(() => {
    if (!CampaignUserList.includes(userEmail) || !currentUser.storeCode.includes('DDS')) {
      const url = '/admin/dashboard';
      window.history.pushState('', '', url);
    }
  }, []);

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDealDropList([]);
    SetFileList([]);
    const files = event.target.files;
    if (files && files.length > 0) {
      const combinedArray: any = [];
      const tempFileList: any = [];
      Array.from(files).forEach((file) => {
        Papa.parse(file, {
          delimiter: '|',
          header: true,
          complete: (results: any) => {
            const file = {
              aMCampaignId: results.data[0]['aMCampaignId'],
              aMCampaignName: results.data[0]['aMCampaignName'],
              startDate: results.data[0]['startDate'],
              endDate: results.data[0]['endDate'],
            };
            tempFileList.push(file);
            combinedArray.push(...results.data);
            checkFileData(combinedArray);
          },
        });
      });
      SetFileList(tempFileList);
    }
  };

  const checkFileData = (data) => {
    const dealerCount = data.reduce((acc, dealer) => {
      const dealerId = dealer['dealer id'];
      const startDate = dealer.startDate;
      const endDate = dealer.endDate;
      const campaignId = dealer.aMCampaignId;
      const campaignName = dealer.aMCampaignName;
      const isActive = true;
      if (dealerId) {
        acc[dealerId] = acc[dealerId] || {
          count: 0,
          startDate,
          endDate,
          campaignId,
          campaignName,
          isActive,
        };
        acc[dealerId].count += 1;
      }
      return acc;
    }, {});

    const dealerListTemp = Object.entries(dealerCount).map(([dealerId, dealerData]) => {
      const { count, startDate, endDate, campaignId, campaignName, isActive } = dealerData as {
        count: number;
        startDate: string;
        endDate: string;
        campaignId: string;
        campaignName: string;
        isActive: boolean;
      };
      return {
        dealerId,
        count,
        startDate,
        endDate,
        campaignId,
        campaignName,
        isActive,
      };
    });
    setDealerList(dealerListTemp);
  };

  async function getStores() {
    try {
      const path = '/common/stores';
      const response = await GetOneFromPath<StoreDetails[]>(path);

      const numberOfActiveStores = response.map((e) => {
        return {
          storeCode: e.storeCode,
          dealerList: e.storeDealers,
        };
      });
      setActiveStore(numberOfActiveStores);
    } catch {}
  }

  const mapStorewithDealer = (dealerId, checkAll, index, checkWith) => {
    SetLoading(true);
    let dealerData = {
      storeCode: '',
      isActive: true,
    };
    activeStore.forEach((e) => {
      e.dealerList.forEach((dealer) => {
        if (dealer.dealerId == dealerId) {
          dealerData.storeCode = e.storeCode;
          dealerData.isActive = dealer.isActive;
        }
      });
    });
    if (checkWith == 'elastic') {
      matchWithElastic(dealerData, dealerId, checkAll, index);
    } else {
      checkNotificationData(dealerData, dealerId, checkAll, index);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const formatDateNotification = (dateString) => {
    const [year, month, day] = dateString.split('T')[0].split('-');
    return `${month}/${day}/${year}`;
  };

  const matchWithElastic = (dealerData, dealerId, checkAll, index) => {
    const currentDealTypeRequest = {
      currentPage: 0,
      recordsPerPage: 10,
      search: '',
      sort: 'bps',
      sortDirection: 'desc',
      dealType: null,
      status: null,
      subStatus: [],
      bps: { min: 0, max: 100 },
      inMarketScore: { min: 0, max: 100 },
      vehicleScore: { min: 0, max: 100 },
      dealScore: { min: 0, max: 100 },
      colors: null,
      optOutPreference: null,
      currentModels: null,
      currentTrims: null,
      currentYears: null,
      currentVehicleMakes: null,
      currentVehicleBrandIds: null,
      currentVehicleType: null,
      replacementVehicleSelection: 1,
      assigneeNames: null,
      replacementModels: null,
      replacementTrims: null,
      replacementVehicleMakes: null,
      replacementVehicleBrandIds: null,
      replacementYears: null,
      filteredDealTypes: [],
      replacementVehicleTypes: [],
      lastUpdated: { min: 0, max: 10000 },
      paymentsRemaining: { min: null, max: null },
      currentVehicleRate: { min: null, max: null },
      replacementVehicleRate: { min: null, max: null },
      currentVehicleMileage: { min: null, max: null },
      replacementVehicleMileage: { min: null, max: null },
      monthsOfOwnership: { min: null, max: null },
      ageDays: { min: null, max: null },
      lastServiceDate: { min: null, max: null },
      isTrimConfirmationRequired: null,
      soldBy: [],
      incentives: ['Private incentive'],
      insights: [],
      recall: [],
      campaignActivityViewCounts: [],
      campaignExpiryDates: [formatDate(dealerList[0].endDate)],
    };

    const token = GetToken('user');
    const authHeader = setAuthHeader(token);

    fetch(`${apiUrl}/dashboard/portfolioDashboard?storeCode=${dealerData.storeCode}`, {
      method: 'POST',
      headers: authHeader,
      body: JSON.stringify(currentDealTypeRequest),
    })
      .then((response) => response.json())
      .then((data) => {
        const newData = dealerList.map((dealer) => {
          if (dealer.dealerId === dealerId) {
            dealer.elasticCount = data.totalCount;
            dealer.isActive = dealerData.isActive;
          }
          return dealer;
        });
        setDealerList(newData);
        SetLoading(false);
        if (checkAll) {
          checkAllDealer(index + 1, 'elastic');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        SetLoading(false);
      });
  };

  const checkAllDealer = (index, type) => {
    if (index < dealerList.length) {
      mapStorewithDealer(dealerList[index].dealerId, true, index, type);
    }
  };

  const checkNotificationData = (dealerData, dealerId, checkAll, index) => {
    const token = GetToken('user');
    const authHeader = setAuthHeader(token);

    const existingCount = dealerList.find((dealer) => dealer.dealerId === dealerId);
    if (existingCount && existingCount.notificationCount) {
      if (checkAll) {
        checkAllDealer(index + 1, 'notification'); // Proceed to the next dealer
      }
      SetLoading(false);
      return;
    }

    if (dealerData && dealerData.isActive) {
      fetch(
        `${apiUrl}/common/notifications?isConquestEnabled=true&storeCode=${dealerData.storeCode}`,
        {
          method: 'GET',
          headers: authHeader,
        },
      )
        .then((response) => {
          if (!response.ok) {
            // Throw an error if the response status is not OK (e.g., 404, 500)
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          let count = '';
          data.forEach((e) => {
            if (
              e.notificationType == 'PrivateIncentive' &&
              formatDateNotification(e.date) == formatDate(dealerList[0].endDate) &&
              e.dealerId == dealerId
            ) {
              count = e.notificationValue;
            }
          });
          const newData = dealerList.map((dealer) => {
            if (dealer.dealerId === dealerId) {
              dealer.notificationCount = count;
              dealer.percentage = (
                ((dealer.count - dealer.notificationCount) / dealer.count) *
                100
              ).toFixed(2);
            }
            return dealer;
          });
          const dropData = newData.filter((dealer) => dealer.percentage >= 5);
          setDealerList(newData);
          setDealDropList(dropData);
          SetLoading(false);
          if (checkAll) {
            checkAllDealer(index + 1, 'notification');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          SetLoading(false);
          if (checkAll) {
            checkAllDealer(index + 1, 'notification');
          }
        });
    } else {
      const newData = dealerList.map((dealer) => {
        if (dealer.dealerId === dealerId) {
          dealer.isActive = dealerData.isActive;
          dealer.notificationCount = 'Inactive Dealer';
        }
        return dealer;
      });
      setDealerList(newData);
      SetLoading(false);
      if (checkAll) {
        checkAllDealer(index + 1, 'notification');
      }
    }
  };

  const generateCsvFile = (csvData, filename) => {
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const convertToCSV = (data) => {
    if (!data || data.length === 0) return '';

    // Define the headers for the CSV
    const headers = [
      'Dealer Id',
      'Deal Count',
      'Elastic Count',
      'Notification Count',
      '% Deal drop',
    ];

    // Map the data to rows
    const rows = data.map((dealer) => [
      dealer.dealerId,
      dealer.count,
      dealer.elasticCount || '',
      dealer.notificationCount || '',
      dealer.percentage || '',
    ]);

    // Combine headers and rows into a CSV string
    const csvContent = [headers.join(','), ...rows.map((row) => row.join(','))].join('\n');

    generateCsvFile(csvContent, Date.now() + '_dealer.csv');
  };

  return (
    <Wrapper>
      {loading && <Loader />}

      <h2>Campaign Test</h2>
      <input type='file' accept='.psv' multiple onChange={handleFileUpload} />

      {dealerList.length > 0 && (
        <>
          <table>
            <thead>
              <tr>
                <th>Campaign Name</th>
                <th>Campaign Id</th>
                <th>Start Date</th>
                <th>End Date</th>
              </tr>
            </thead>
            <tbody>
              {fileList.map((file, i) => (
                <tr key={i}>
                  <td>{file.aMCampaignName}</td>
                  <td>{file.aMCampaignId}</td>
                  <td>{file.startDate}</td>
                  <td>{file.endDate}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h4>
            <b>Total Dealer: </b>
            {dealerList.length}
          </h4>
          {'  '}
          {/* <button onClick={() => checkAllDealer(0, 'elastic')}>Check All Using Elstic</button> */}
          {'  '}
          <div>
            <button onClick={() => checkAllDealer(0, 'notification')}>
              Check All Using Notification
            </button>
            {'  '}
            <button onClick={() => convertToCSV(dealerList)}>Download CSV</button>
          </div>

          <table className={'deal-drop'}>
            <thead>
              <tr>
                <th>Dealer Id</th>
                <th>Deal Count</th>
                <th>Check Elastic</th>
                <th>Elastic Search</th>
                <th>Check Notification</th>
                <th>Notification</th>
                <th>% Deal drop </th>
              </tr>
            </thead>
            <tbody>
              {dealerList.map((dealer, i) => (
                <tr key={i} className={dealer.isActive ? '' : 'notActive'}>
                  <td className={dealer.dealerId.includes('DDS') ? 'demo-dealer' : ''}>
                    {dealer.dealerId}
                  </td>
                  <td>{dealer.count}</td>
                  <td>
                    <button
                      onClick={() => mapStorewithDealer(dealer.dealerId, false, 0, 'elastic')}
                    >
                      Check
                    </button>
                  </td>
                  <td>{dealer.elasticCount}</td>

                  <td>
                    <button
                      onClick={() => mapStorewithDealer(dealer.dealerId, false, 0, 'notification')}
                    >
                      Check
                    </button>
                  </td>
                  <td className={dealer.percentage && dealer.percentage < 0 ? 'red' : ''}>
                    {dealer.notificationCount}
                  </td>
                  {dealer.isActive ? (
                    <td>{dealer.percentage ? dealer.percentage + ' %' : ''}</td>
                  ) : (
                    <td>Inative Dealer</td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>

          {dealDropList && dealDropList.length > 0 && (
            <div className={'deal-drop'} style={{ marginTop: '10px' }}>
              <h4> Deal drop more than 5%. </h4>
              <table>
                <thead>
                  <tr>
                    <th>Dealer Id</th>
                    <th>Deal Count</th>
                    <th>Notification</th>
                    <th>% Deal drop</th>
                  </tr>
                </thead>
                <tbody>
                  {dealDropList.map((dealer, i) => (
                    <tr key={i}>
                      <td>{dealer.dealerId}</td>
                      <td>{dealer.count}</td>
                      <td>{dealer.notificationCount}</td>
                      <td>{dealer.percentage + ' %'} </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </Wrapper>
  );
};

export default CampaignTest;

const Wrapper = styled.div`
  padding: 50px;
  h2 {
    margin-top: 0px;
  }
  table {
    border: 1px solid black;
    tr {
      padding: 10px;
      td,
      th {
        padding: 10px;
        border: 1px solid black;
      }
    }
    .demo-dealer {
      background-color: orange;
    }
    .red {
      background-color: #f89406;
    }
    .notActive {
      background-color: red;
      color: white;
    }
  }
  button {
    font-size: 14px;
    color: rgb(255, 255, 255);
    background-color: rgb(117, 41, 165);
    text-align: center;
    border-radius: 8px;
    padding: 7px;
    font-weight: 600;
  }
  .deal-drop {
    float: left;
    margin: 50px;
  }
`;
